import { render } from "./polygonMap.vue?vue&type=template&id=5638a7b6&scoped=true"
import script from "./polygonMap.vue?vue&type=script&lang=js"
export * from "./polygonMap.vue?vue&type=script&lang=js"

import "./polygonMap.vue?vue&type=style&index=0&id=5638a7b6&scoped=true&lang=css"
/* custom blocks */
import block0 from "./polygonMap.vue?vue&type=custom&index=0&blockType=doc"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5638a7b6"]])

export default __exports__